import Button from '../../Button/Button';
import './Paginator.css';

interface PaginatorProps {
  currentStep: number;
  numberOfSteps: number;
  previous: () => void;
  next: () => void;
}

const Paginator = ({
  currentStep,
  numberOfSteps,
  previous,
  next,
}: PaginatorProps) => (
  <div className="paginator">
    {/* Disabled at first row — no previous row to navigate to */}
    <Button onClick={previous} disabled={currentStep === 1}>
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_549_1630)">
          <path d="M7 0.5L2.5 5L7 9.5L7 0.5Z" fill="#FFFFFF" />
        </g>
        <defs>
          <clipPath id="clip0_549_1630">
            <rect
              width="10"
              height="10"
              fill="white"
              transform="translate(10) rotate(90)"
            />
          </clipPath>
        </defs>
      </svg>
    </Button>
    <h2>{`${currentStep} / ${numberOfSteps}`}</h2>
    {/* Disabled at last row — no next row to navigate to */}
    <Button onClick={next} disabled={currentStep === numberOfSteps}>
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_54_3060)">
          <path d="M3 9.5L7.5 5L3 0.5L3 9.5Z" fill="#FFFFFF" />
        </g>
        <defs>
          <clipPath id="clip0_54_3060">
            <rect
              width="10"
              height="10"
              fill="white"
              transform="translate(0 10) rotate(-90)"
            />
          </clipPath>
        </defs>
      </svg>
    </Button>
  </div>
);

export default Paginator;
